export default "assets/images/icons/member-2760c075.svg";